export default __webpack_public_path__ + "static/media/coupon.3ba2b7ad.svg";